export default __webpack_public_path__ + "static/media/outdoor-storage.33d1f5ce.svg";